import type { ReactElement } from 'react';
import type { ModelProfileResponse } from '@fetmode/types';
import { t } from '@fetmode/i18n';
import { Button } from '@fetmode/ui';
import { Link } from 'react-router-dom';

export interface StartOnboardingCardProps {
  profile?: ModelProfileResponse | null;
}

export function StartOnboardingCard({ profile }: StartOnboardingCardProps): ReactElement {
  return (
    <div className="fm-card">
      <h2 style={{ marginTop: 0, fontSize: '1.125rem' }}>{t('common.studio.live.becomeModel')}</h2>
      <p style={{ color: 'var(--fm-color-text-muted)' }}>
        {profile
          ? t('common.studio.onboarding.broadcastLocked')
          : t('common.studio.onboarding.lede')}
      </p>
      <div style={{ marginTop: '1rem' }}>
        <Link to="/onboarding">
          <Button
            label={
              profile
                ? t('common.studio.onboarding.ctaContinue')
                : t('common.studio.onboarding.ctaStart')
            }
          />
        </Link>
      </div>
    </div>
  );
}
